import { IPhoneSchema } from '../../../repositories/newbuilding-card/entities/builder/PhoneSchema';

export const isCorrectPhoneObject = (phone?: IPhoneSchema | null): boolean => {
  return !!(phone && phone.countryCode && phone.code && phone.number);
};
